import { Button as CarbonButton } from 'carbon-components-react'
import withUbliqueStyle from '../UbliqueStyle'

import './index.scss'

const Button = withUbliqueStyle(CarbonButton, 'ublique-button')

export { Button, Button as default }
